/* eslint-disable no-undef */

function setCookie(cookieName, value, exdays) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  const cookieValue = `${
    escape(value) + (exdays == null ? '' : `; expires=${exdate.toUTCString()}`)
  }; path=/`;
  document.cookie = `${cookieName}=${cookieValue}`;
}

export default setCookie;
